import { Box, Paper, Stack, Typography } from "@mui/material";

import { currencyFormatter } from "../../../../lib/presentation";
import type { RankedRow } from "./purchaseBehaviorUtils";

export default function PurchaseBehaviorRankedPanel({
    rows,
    title,
}: {
    rows: RankedRow[];
    title: string;
}) {
    return (
        <Paper className="table-card" elevation={0}>
            <Box className="table-card__header">
                <Typography variant="h5">{title}</Typography>
            </Box>
            <Stack spacing={1}>
                {rows.length === 0 ? (
                    <Typography color="text.secondary">Няма достатъчно данни.</Typography>
                ) : (
                    rows.map((row) => <RankedLine key={row.label} row={row} />)
                )}
            </Stack>
        </Paper>
    );
}

function RankedLine({ row }: { row: RankedRow }) {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 1,
                p: 1,
                borderRadius: 2,
                bgcolor: "rgba(248, 250, 252, 0.88)",
            }}
        >
            <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontWeight: 800, overflowWrap: "anywhere" }}>
                    {row.label}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {row.count} покупки
                </Typography>
            </Box>
            <Typography sx={{ fontWeight: 900, whiteSpace: "nowrap" }}>
                {currencyFormatter.format(row.value)}
            </Typography>
        </Box>
    );
}
